<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/user">{{ $t('user_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('user_update')}} [{{model.UserName}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="flex-container">
                                <div>
                                    <div>
                                        <input type="file" ref="file" @change="fileChangeHandler" style="display:none;"/>
                                        <img :src="img" alt="" class="img-thumbnail" style="width: 150px; height:135px;" @click="$refs.file.click()">
                                    </div>
                                </div>
                                <div class="flex-right">
                                    <div class="form-group">
                                        <label class="label-control blue">{{$t('user_name')}}</label>
                                        <input type="email" class="form-control form-control-sm" v-model="model.UserName" readonly />
                                    </div>
                                    <div class="form-group" :class="{ 'form-group-error': $v.model.DisplayName.$error }">
                                        <label class="label-control blue">{{$t('display_name')}}</label>
                                        <input type="text" class="form-control form-control-sm" v-model="$v.model.DisplayName.$model" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Email.$error }">
                                <label class="label-control blue">{{$t('user_email')}}</label>
                                <input type="email" class="form-control form-control-sm" v-model="$v.model.Email.$model" />
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.PhoneNumber.$error }">
                                <label class="label-control blue">{{$t('phone')}}</label>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.PhoneNumber.$model" />
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.GroupId.$error }">
                                <label class="label-control blue">{{$t('user_group')}}</label>
                                <select class="form-control form-control-sm" v-model="$v.model.GroupId.$model" @change="groupChange">
                                    <option v-for="ret in groups" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <template v-for="(ret,index) in modules">
                                <template v-if="ret.Children.length>0">
                                    <div :key="index" style="padding: 10px 0;border-bottom: 1px solid #ddd;font-weight: 700;color: #0856ab;">{{ret.Name}}</div>
                                    <div v-for="item in ret.Children" :key="item.Id" style="padding: 5px;border-bottom: 1px solid #f2f2f2;">
                                        <input type="checkbox" v-model="item.Checked"/> {{item.Name}}
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>          
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
export default {
    data(){
        return {
            model: {
                Email: '',
                PhoneNumber: '',
                DisplayName: '',
                GroupId: ''
            },
            img: '/img/no-image.svg',
            file: '',
            formHead: { headers: { 'Content-Type': 'multipart/form-data' }},
            groups: [],
            modules: []
        }
    },
    validations:{
        model: {
            Email: { required },
            PhoneNumber: { required },
            DisplayName: { required },
            GroupId: { required }
        }
    },
    created(){
        var loading = this.$loading.show();
        this.listGroup();
        this.$api().post('account/find', { Id: this.$route.params.id }).then(res => {
            if(this.$isValid(res)){
                this.model = res.data.Json.User;
                if(res.data.Json.UserInfo != undefined){
                    this.img = this.$base() + 'image/profile?id=' + res.data.Json.UserInfo.Profile;
                }
                this.groupChange();
            }
        }).finally(function() { loading.hide(); });
    },
    methods: {
        clickSaveHandler(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                var loading = this.$loading.show();
                var formData = new FormData();
                formData.append('File', this.$refs.file.files[0]);
                formData.append('Id', this.model.Id);
                formData.append('UserName', this.model.UserName);
                formData.append('Email', this.model.Email);
                formData.append('PhoneNumber', this.model.PhoneNumber);
                formData.append('GroupId', this.model.GroupId);
                formData.append('DisplayName', this.model.DisplayName);
                let jsonMenus = [];
                this.modules.forEach(el => {
                    for(var i = 0; i < el.Children.length; i++){
                        let item = el.Children[i];
                        if(item.Checked){
                            jsonMenus.push({
                                MenuId: item.Id
                            });
                        }
                    }
                });
                formData.append("JsonMenu", JSON.stringify(jsonMenus));
                this.$api().post('account/update/user', formData, this.formHead).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/user');
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        fileChangeHandler(){
            this.img = URL.createObjectURL(this.$refs.file.files[0]);
        },
        listGroup(){
            this.$api().post('user/groups', {}).then(res => {
                if(this.$isValid(res)){
                    this.groups = res.data.Json.Groups;
                }
            });
        },
        groupChange(){
            let loading = this.$loading.show();
            this.$api().post('user/module-group', { GroupId: this.model.GroupId, UserId: this.$route.params.id}).then(res => {
                if(this.$isValid(res)){
                    this.modules = res.data.Json.Modules;
                }
            }).finally(() => loading.hide());
        }
    }
}
</script>
